//src/App.jsx
import { ImageCrop } from 'components/AccountComponent/pic-image-crop';
import { ImageCropProvider } from 'components/AccountComponent/pic-image-crop-provider';
import React from 'react';

interface PicPageProps {
  profilePicture?: any;
  onClose: () => void;
  uploadImage: (base64: File) => void;
  mode?: 'preview' | 'edit';
}

export const PicPage: React.FC<PicPageProps> = ({
  profilePicture,
  onClose,
  uploadImage,
  mode = 'edit',
}) => {
  return (
    <ImageCropProvider>
      <ImageCrop
        profilePicture={mode === 'preview' ? profilePicture : undefined}
        onClose={onClose}
        uploadImage={uploadImage}
        mode={mode}
      />
    </ImageCropProvider>
  );
};

export default PicPage;
